// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1miI1","col":"styles_col__1GmD0","actions":"styles_actions__1iCGJ","conflict":"styles_conflict__XRgxr"};